import { useAppSelector } from '../../../redux/store';
import useGetData from '../../../Services/useGetData';
import globals from '../../../Globals.json';
import * as S from './styles';
import PanelLoading from '../../Loading/PanelLoading';
import Format from '../../../Services/Format';
import { useHistory } from 'react-router';
import { AiOutlineBank } from "react-icons/ai";
import { RiBankFill } from "react-icons/ri";
interface IBanksAccounts {
  description: string;
  balance: string;
}

export function BankAccounts() {
  const router = useHistory();
  const { storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  const { data, isLoading } = useGetData({
    path: globals?.api?.bankAccountsDash,
    query: `store_id=${storeActive?.id}`,
  });

  const handleNew = () => {
    router.push(`/dashboard/financeiro/contas-bancarias`);
  };

  return (
    <S.Container>
      <div className="menu-top">
        <h3>Contas Bancárias</h3>
        <button onClick={handleNew}>Nova Conta</button>
      </div>
      <div className="wrapper">
        {isLoading && <PanelLoading />}
        {data?.bank_accounts?.map((bank: IBanksAccounts, index: number) => (
          <div key={index} className="details">
            <div className="left">
              <RiBankFill size={20} />
              <span className="description">{bank?.description}</span>
            </div>
            <span
              className={`balance ${Number(bank?.balance) === 0
                ? 'amount-neutral'
                : Number(bank?.balance) > 0
                  ? 'amount-green'
                  : 'amount-red'
                }`}
            >
              {Format.formatCurrencyBr(bank?.balance ?? 0)}
            </span>
          </div>
        ))}
      </div>
    </S.Container>
  );
}
